import { Form } from "react-bootstrap";

const TestStripForm = ({ formData, handleChange, showValidationError }) => {
  return (
    <>
      <Form.Group>
        <Form.Label className='fs-6 fw-semibold'>Test Strip Type:</Form.Label>
        <div className='mb-3'>
          <Form.Check
            inline
            type='radio'
            name='testStripType'
            id='fentanyl'
            label='Fentanyl'
            value='Fentanyl'
            checked={formData.type === "Fentanyl"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='testStripType'
            id='benzodiazepine'
            label='Benzodiazepine'
            value='Benzodiazepine'
            checked={formData.type === "Benzodiazepine"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='testStripType'
            id='xylazine'
            label='Xylazine'
            value='Xylazine'
            checked={formData.type === "Xylazine"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='testStripType'
            id='medetomidine'
            label='Medetomidine'
            value='Medetomidine'
            checked={formData.type === "Medetomidine"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='testStripType'
            id='nitazene'
            label='Nitazene'
            value='Nitazene'
            checked={formData.type === "Nitazene"}
            onChange={(e) => handleChange("type", e.target.value)}
          />
          {showValidationError && !formData.type && (
            <div className='invalid-feedback d-block'>
              Please select a test strip type.
            </div>
          )}
        </div>
      </Form.Group>
      <Form.Group>
        <Form.Label className='fs-6 fw-semibold'>Result:</Form.Label>
        <div className='mb-3'>
          <Form.Check
            inline
            type='radio'
            name='testStripResult'
            id='positive'
            label='Positive'
            value='Positive'
            checked={formData.results === "Positive"}
            onChange={(e) => handleChange("results", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='testStripResult'
            id='negative'
            label='Negative'
            value='Negative'
            checked={formData.results === "Negative"}
            onChange={(e) => handleChange("results", e.target.value)}
          />
          <Form.Check
            inline
            type='radio'
            name='testStripResult'
            id='inconclusive'
            label='Inconclusive'
            value='Inconclusive'
            checked={formData.results === "Inconclusive"}
            onChange={(e) => handleChange("results", e.target.value)}
          />
          {showValidationError && !formData.results && (
            <div className='invalid-feedback d-block'>
              Please select a test result.
            </div>
          )}
        </div>
      </Form.Group>
      <Form.Group>
        <Form.Label className='fs-6 fw-semibold'>Comments:</Form.Label>
        <Form.Control
          as='textarea'
          rows={3}
          defaultValue={formData.comments}
          onChange={(e) => {
            handleChange("comments", e.target.value);
          }}
        />
      </Form.Group>
    </>
  );
};

export default TestStripForm;
